import React, {useContext} from "react";
import {CreateDeliveryContext} from "../../CreateDeliveryRequest";
import {
    OrderInformationContainer,
    CustomerOrderInformationContainer
} from "./OrderInformation.styles";
import {Col, Row} from "antd";
import {OrderBlock} from "./orderBlock/OrderBlock";
import {UploadExcelFromTemplate} from "../pickupInformation/components/UpdateExcelFromTemplate";

export const OrderInformation = () => {
    const {orderList, isFromCustomerTheme, selectedSubCompany} = useContext(CreateDeliveryContext);

    // Choose styles based on customer theme
    const ContainerComponent = isFromCustomerTheme
        ? CustomerOrderInformationContainer
        : OrderInformationContainer;

    return (
        <ContainerComponent>
            <Row style={{width: "100%"}}>
                {isFromCustomerTheme && selectedSubCompany && <UploadExcelFromTemplate />}
                {orderList.map((order, index) => {
                    return (
                        <Col key={index} span="24">
                            <OrderBlock
                                order={order}
                                index={index}
                                isLast={index === orderList.length - 1}
                            />
                        </Col>
                    );
                })}
            </Row>
        </ContainerComponent>
    );
};
